import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { setInitializedComponent, setValue, reducer } from './Postal';

const initialState = {
  type: 'RadioChannel',
  showSidebarChannelCard: false,
  showHighlights: false,
  showRecentEpisodes: false,
  showNavigator: false,
};

const RadioChannel = ({ components, handlerSetComponents, id }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const componentIndex = components.findIndex(obj => obj.id === id);
  const { component } = components[componentIndex];

  useEffect(() => {
    if (component) setInitializedComponent(dispatch)(component);
  }, []);

  const handleToggle = (e) => {
    const { name, checked } = e.target;
    setValue(dispatch)(name, checked);
  };

  useEffect(() => {
    const updatedComponent = {
      id,
      component: state,
    };

    handlerSetComponents(updatedComponent, componentIndex);
  }, [state]);

  return (
    <div className="flex justify-between text-black rounded-t border-1 p-4">
      {/* Toggle */}
      <div className="flex items-center">
        <label htmlFor="sidebar" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Show Sidebar Card</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            id="sidebar"
            name="showSidebarChannelCard"
            value={state.showSidebarChannelCard}
            onChange={handleToggle}
            checked={state.showSidebarChannelCard}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="sidebar" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
        </div>
      </div>
      {/* End Toggle */}
      <div className="flex items-center">
        <label htmlFor="recentEpisodes" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Show Recent Episodes List</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="showRecentEpisodes"
            id="recentEpisodes"
            value={state.showRecentEpisodes}
            onChange={handleToggle}
            checked={state.showRecentEpisodes}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="recentEpisodes" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
        </div>
      </div>
      <div className="flex items-center">
        <label htmlFor="highlights" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Show Highlights</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="showHighlights"
            id="highlights"
            value={state.showHighlights}
            onChange={handleToggle}
            checked={state.showHighlights}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="highlights" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
        </div>
      </div>
      <div className="flex items-center">
        <label htmlFor="navigator" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Show Navigator</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="showNavigator"
            id="navigator"
            value={state.showNavigator}
            onChange={handleToggle}
            checked={state.showNavigator}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="navigator" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
        </div>
      </div>
    </div>
  );
};

RadioChannel.propTypes = {
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default RadioChannel;
